import axios from "axios";
import { combinedUrls } from "../../../../../../URL/functions";
import { projectUrls } from "../../../../../../URL/ApplicationUrls";

export async function useAddPlantDock(
  plantDock: string,
  projectId: number | undefined,
  ftlRouteId: number
) {
  const url = combinedUrls(
    projectUrls.projectFtlRouteApiUrl({
      projectId,
      ftlRouteId,
    }),
    `/AddDock`
  );

  return axios.post(url, { PlantDockCombination: plantDock }).then((response) => {
    return response.data;
  });
}
